import Vue from 'vue';

Vue.filter('formatDate', function (date) {
  let d = new Date(date);
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  let year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [day, month, year].join('.');
})



// WEBPACK FOOTER //
// ./src/filters/FormatDate.js